import React, { Suspense } from "react";
// route
import { useRoutes } from "react-router-dom";
// antd
import { ConfigProvider } from "antd"; // 导入loading组件，旋转的图标
// 自定义样式
import "./App.css";
// 我的组件
import NavigatorAntd from "@/components/Navigator/NavbarAntd.jsx";
// import MusicPlayer from "@/components/MusicPlayer";
import DraggableMenu from "@/components/menu/DraggableMenu";
// 加载动画
import Loading from "@/components/Loading";
/// 动画
//// 逐渐不透明的动画
import MotionOpaque from "@/components/FramerMotion/MotionOpaque";
// 导入路由表
import routes from "@/routes/routes";
// 主题
// https://ant.design/docs/react/customize-theme-cn#%E5%8A%A8%E6%80%81%E5%88%87%E6%8D%A2
import { theme } from "antd";

// # 动态切换
// const { getDesignToken } = theme;
// const globalToken = getDesignToken();
// console.log(1100, globalToken);
//
export default function App() {
  // 使用路由表
  const element = useRoutes(routes);
  //
  const themeLight = {
    // algorithm: theme.darkAlgorithm, // 黑暗预设主题
    algorithm: theme.defaultAlgorithm,  // 默认预设主题
    token: {
      colorPrimary: "#f97d1c", // 主色:橙色
      borderRadius: 2, // 圆角: 0直角
      colorBackground: "#f0fbf3", // 整个网页的背景颜色
      borderRadiusLG:2
    },
    components: {
      Menu: {
        // horizontalItemHoverBg: '#ffbe90'  // 触摸的反馈(显示)的颜色 / 横向菜单项横悬浮态背景色
        // itemBg: '#f0fbf3',
        // activeBarHeight: 2,
        // activeBarBorderWidth: 0,
        // activeBarWidth: 0
        subMenuItemBorderRadius: 8,  // 子菜单 选中圆角
      },
    },
  };
  //
  // const themeDark = {
  //   token: {
  //     colorPrimary: "#212c3a",
  //     colorBgBase: "#000000",
  //     colorTextBase: "#ffffff",
  //   },
  // };
  return (
    <>
      <ConfigProvider
        theme={themeLight}
        // theme={themeDark}
      >
        {/* <Navigator /> */}
        <NavigatorAntd />
        <Suspense fallback={<Loading/>}>
          {/*懒加载 loading动画设置*/}
          <MotionOpaque duration={1}  >
            {/* 在第一次进入页面时，路由的页面将逐渐从透明到不透明 */}
              {element}
          </MotionOpaque>
        </Suspense>
        {/* <MusicPlayer /> */}
        <DraggableMenu />
      </ConfigProvider>
    </>
  );
}
